// Module
var code = `<div role="status" class="w-full max-w-full h-2 animate-pulse" ng-class="\$ctrl.boxClass"> <div class="indicator-dummy h-full w-full bg-gray-300" ng-class="{ 'rounded': !\$ctrl.type, 'rounded-full aspect-square': \$ctrl.type == 'circle', 'rounded-sm': \$ctrl.type == 'box' }"></div> </div>`;
// Exports
export default code;